// extracted by mini-css-extract-plugin
export default {"input":"lsf-input","textarea":"lsf-textarea","input__spinner":"lsf-input__spinner","waiting-spin":"lsf-waiting-spin","waiting":"lsf-waiting"};
    if(module.hot) {
      // 1653630377037
      var cssReload = require("/home/runner/work/label-studio-frontend/label-studio-frontend/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  